/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Step_3_DescInputs */

const es_home_intro_step_3_desc = /** @type {(inputs: Home_Intro_Step_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace preguntas naturales como '¿Cuándo enviamos el presupuesto al cliente X?'`)
};

const en_home_intro_step_3_desc = /** @type {(inputs: Home_Intro_Step_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask natural questions like 'When did we send the budget to client X?'`)
};

/**
* | output |
* | --- |
* | "Ask natural questions like 'When did we send the budget to client X?'" |
*
* @param {Home_Intro_Step_3_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_step_3_desc = /** @type {((inputs?: Home_Intro_Step_3_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Step_3_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_step_3_desc(inputs)
	return en_home_intro_step_3_desc(inputs)
});
export { home_intro_step_3_desc as "home.intro.step_3_desc" }